import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const ZoraField = ({set, get, name, isTextArea}) => { 
    const [focused, setFocused] = useState(false);
    let className = "zora-field ";
    if (focused || get !== "") {
        className += " focused";
    }
    if (isTextArea) {
        className += " text-area";
    }
    return (
        <div className={className}>
          <div className="field-name">
            {name}
          </div>
        {isTextArea ?
         <textarea
            onFocus={e => setFocused(true)}
            onBlur={e => setFocused(false)}
            value={get}
            onChange={e => set(e.target.value)}
           type="text"/> :
         <input
            onFocus={e => setFocused(true)}
            onBlur={e => setFocused(false)}
            value={get}
            onChange={e => set(e.target.value)}
            type="text"/>}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZoraField);
